import { render, staticRenderFns } from "./UsersLockUserScreen.vue?vue&type=template&id=9edec810&scoped=true&"
import script from "./UsersLockUserScreen.vue?vue&type=script&lang=js&"
export * from "./UsersLockUserScreen.vue?vue&type=script&lang=js&"
import style0 from "./UsersLockUserScreen.vue?vue&type=style&index=0&id=9edec810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edec810",
  null
  
)

export default component.exports